const bindings = new WeakMap();

const bindColetHeader = (header) => {
  if (!header || bindings.has(header)) return;

  const controller = new AbortController();
  const { signal } = controller;
  bindings.set(header, controller);
  const groups = [...header.querySelectorAll('[data-colet-nav-group]')];
  const mobileMenu = header.querySelector('.colet-mobile-menu');
  const mobileToggle = mobileMenu?.querySelector(':scope > summary');
  const mobileQuery = window.matchMedia('(max-width: 560px)');
  let backgroundFadeTimer;
  const finishBackgroundFade = () => {
    window.clearTimeout(backgroundFadeTimer);
    header.classList.remove('is-background-fading');
  };
  const fadeBackgroundOut = () => {
    if (mobileQuery.matches || header.matches(':hover, :focus-within') || groups.some((group) => group.open)) return;
    window.clearTimeout(backgroundFadeTimer);
    header.classList.add('is-background-fading');
    backgroundFadeTimer = window.setTimeout(finishBackgroundFade, 250);
  };
  header.addEventListener('pointerenter', finishBackgroundFade, { signal });
  header.addEventListener('pointerleave', fadeBackgroundOut, { signal });
  header.addEventListener('focusout', () => queueMicrotask(fadeBackgroundOut), { signal });
  header.addEventListener('transitionend', (event) => {
    if (event.target === header && event.propertyName === 'background-color') finishBackgroundFade();
  }, { signal });
  signal.addEventListener('abort', finishBackgroundFade, { once: true });

  const closeGroups = (except = null) => {
    groups.forEach((group) => {
      if (group !== except) {
        group.open = false;
        group.querySelector('summary').setAttribute('aria-expanded', 'false');
      }
    });
  };

  const alignDropdown = (group) => {
    const panel = group.querySelector('.colet-header__dropdown');
    if (panel) panel.style.setProperty('--colet-submenu-left', `${group.querySelector('summary').getBoundingClientRect().left}px`);
  };

  const update = () => {
    header.classList.toggle('is-scrolled', header.dataset.scrollBackground === 'true' && window.scrollY > 2);
    groups.filter((group) => group.open).forEach(alignDropdown);
  };

  groups.forEach((group) => {
    const summary = group.querySelector(':scope > summary');
    summary.addEventListener('click', () => {
      if (!group.open) {
        closeGroups(group);
        alignDropdown(group);
      }
    }, { signal });
    group.addEventListener('toggle', () => {
      summary.setAttribute('aria-expanded', String(group.open));
      if (group.open) {
        closeGroups(group);
        alignDropdown(group);
      }
    }, { signal });
    summary.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowDown') return;
      event.preventDefault();
      closeGroups(group);
      group.open = true;
      alignDropdown(group);
      group.querySelector('a')?.focus();
    }, { signal });
  });

  mobileMenu?.addEventListener('toggle', () => {
    mobileToggle?.setAttribute('aria-expanded', String(mobileMenu.open));
    if (!mobileMenu.open) closeGroups();
  }, { signal });

  document.addEventListener('click', (event) => {
    if (!header.contains(event.target) || event.target.closest('a')) {
      closeGroups();
      queueMicrotask(fadeBackgroundOut);
    }
  }, { signal });

  header.addEventListener('focusout', (event) => {
    if (!mobileMenu?.open && !header.contains(event.relatedTarget)) closeGroups();
  }, { signal });

  header.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      const openGroup = groups.find((group) => group.open);
      if (openGroup) {
        event.preventDefault();
        event.stopPropagation();
        closeGroups();
        openGroup.querySelector('summary').focus();
      } else if (mobileMenu?.open) {
        event.preventDefault();
        mobileMenu.open = false;
        mobileToggle.focus();
      }
    }
    if (event.key !== 'Tab' || !mobileMenu?.open) return;
    const controls = [...mobileMenu.querySelectorAll('summary, a[href]')].filter((element) => element.getClientRects().length);
    const first = controls[0];
    const last = controls[controls.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }, { signal });

  mobileQuery.addEventListener('change', () => {
    closeGroups();
    if (mobileMenu) mobileMenu.open = false;
  }, { signal });
  window.addEventListener('scroll', update, { passive: true, signal });
  window.addEventListener('resize', update, { passive: true, signal });
  update();
};

document.querySelectorAll('[data-colet-header]').forEach(bindColetHeader);

document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll?.('[data-colet-header]').forEach(bindColetHeader);
});

document.addEventListener('shopify:section:unload', (event) => {
  event.target.querySelectorAll?.('[data-colet-header]').forEach((header) => {
    bindings.get(header)?.abort();
    bindings.delete(header);
  });
});
